<template>
  <thead>
    <tr>
      <th scope="col">
        <span class='search-result-header'>ID</span>
        <a @click="changeSort('id')">
          <font-awesome-icon
          :class="getSortClass('id')"
          :icon="getSortIcon('id')"/>
        </a>
      </th>
      <th scope="col">
        <span class='search-result-header'>Project ID</span>
        <a @click="changeSort('projectId')">
          <font-awesome-icon
          :class="getSortClass('projectId')"
          :icon="getSortIcon('projectId')"/>
        </a>
      </th>
      <th scope="col">
        <span class='search-result-header'>Type</span>
        <a @click="changeSort('instrumentType')">
          <font-awesome-icon
          :class="getSortClass('instrumentType')"
          :icon="getSortIcon('instrumentType')"/>
        </a>
      </th>
      <th scope="col">
        <span class='search-result-header'>Staff Lead</span>
        <a @click="changeSort('staffLeadName')">
          <font-awesome-icon
          :class="getSortClass('staffLeadName')"
          :icon="getSortIcon('staffLeadName')"/>
        </a>
      </th>
      <th scope="col">
        <span class='search-result-header'>Status</span>
        <a @click="changeSort('instrumentStatus')">
          <font-awesome-icon
          :class="getSortClass('staffLeadName')"
          :icon="getSortIcon('instrumentStatus')"/>
        </a>
      </th>
      <th scope="col">
        <span class='search-result-header'>Locality</span>
        <a @click="changeSort('localityName')">
          <font-awesome-icon
          :class="getSortClass('localityName')"
          :icon="getSortIcon('localityName')"/>
        </a>
      </th>
      <th scope="col">
        <span class='search-result-header'>Executed Date</span>
        <a @click="changeSort('executedDate')">
          <font-awesome-icon
          :class="getSortClass('executedDate')"
          :icon="getSortIcon('executedDate')"/>
        </a>
      </th>
      <th scope="col"></th>
    </tr>
  </thead>
</template>
<script>
export default {
  name: 'InstrumentSearchResultHeader',
  props: {
    changeSort: {
      type: Function,
    },
    getSortClass: {
      type: Function,
    },
    getSortIcon: {
      type: Function,
    },
  },
};
</script>
